module.exports = __webpack_public_path__ + "img/offers4.9d9cf9b9.jpg";